import React from 'react';
import { PreviewModalProvider } from 'contexts/PreviewModalContext';
import TrainingAdvice from 'containers/pages/prevention/TrainingAdvice';
import { useParams } from 'react-router-dom';

const SessionPersonAdviceTab = () => {
  const { entityId, sessionId, personId } = useParams();
  return (
    <PreviewModalProvider entityId={entityId}>
      <TrainingAdvice
        entityId={entityId}
        sessionId={sessionId}
        personId={personId}
        // testDataId={testData?.id}
      />
    </PreviewModalProvider>
  );
};

export default SessionPersonAdviceTab;
